import {minmax, sectionToFixedMap, portrait, promo} from '../shared.js';

import {
  buildNarrativeTextTimeline,
  dashPaths,
  animateTextHighlights,
  animateCallout,
  animatePages,
} from '../animations.js';

const article = document.querySelector('#chapter6');

const narrativeSection = article.querySelector('#chapter6-narrative');
const narrativeFixed = sectionToFixedMap.get(narrativeSection);
const narrativeText = narrativeFixed.querySelector('.narrative-text');
const narrativeTimeline = new TimelineLite({paused: true});

const infographicSection = article.querySelector('#chapter6-infographic');
const infographicFixed = sectionToFixedMap.get(infographicSection);
const blackoutCurtain = infographicFixed.querySelector('.blackout-curtain');
const fbi = infographicFixed.querySelector('.fbi');
const cia = infographicFixed.querySelector('.cia');
const fbiConflict = fbi.querySelector('.conflict');
const ciaConflict = cia.querySelector('.conflict');
const ciaHighlights = Array.from(ciaConflict.querySelectorAll('.highlight'));
const fbiMemoCallout = infographicFixed.querySelector('#ch6-fbi-memo-callout');
const fbiFootnote = infographicFixed.querySelector('#chapter6-footnote-fbi');
const ciaFootnote = infographicFixed.querySelector('#chapter6-footnote-cia');
const pages = Array.from(infographicFixed.querySelectorAll('.declassified-page'));
const pathHighlights = Array.from(infographicFixed.querySelectorAll('figure svg path'));
const fbiMemoQuote = infographicFixed.querySelector('#ch6-fbi-memo-quote');
const infographicTimeline = new TimelineLite({paused: true});
const infographicTimelinePortrait = new TimelineLite({paused: true});

/**
 * Initialize chapter
 */
export function init() {
  console.log('chapter6:init');

  narrativeSection.addEventListener('active', () => promo.classList.add('active'));
  narrativeSection.addEventListener('inactive', () => promo.classList.remove('active'));

  buildNarrativeTextTimeline(narrativeTimeline, narrativeText, 85);

  narrativeSection.addEventListener('scrub', ({detail: {vh}}) => narrativeTimeline.seek(minmax(0, vh, narrativeTimeline.duration())));

  initInfographic();
}

/**
 * Initialize infographic
 */
function initInfographic() {
  TweenLite.set([fbiConflict, ciaConflict, fbiMemoCallout, fbiMemoQuote, fbiFootnote, ciaFootnote, ...pages], {opacity: 0});
  TweenLite.set(pages, {scale: 1.5});
  TweenLite.set([fbiConflict, fbiMemoCallout], {x: '-=25%'});
  TweenLite.set(ciaConflict, {x: '+=25%'});

  dashPaths(pathHighlights);

  infographicTimeline.set(fbi, {width: '50%'});

  infographicTimeline.to({}, 100, {});

  infographicTimeline.to(blackoutCurtain, 50, {right: '50%'});
  infographicTimeline.add([
    TweenLite.to(ciaConflict, 25, {opacity: 1, x: '0%'}),
    TweenLite.to(ciaFootnote, 25, {opacity: 1}),
  ]);

  infographicTimeline.to({}, 25, {});

  animateTextHighlights(ciaHighlights, infographicTimeline);

  infographicTimeline.to({}, 50, {});

  infographicTimeline.add([
    TweenLite.to(ciaFootnote, 50, {opacity: 0}),
    TweenLite.to(blackoutCurtain, 50, {right: '0%'}),
  ]);
  infographicTimeline.to(blackoutCurtain, 50, {left: '50%'});
  infographicTimeline.to(fbiConflict, 25, {opacity: 1, x: '0%'});

  infographicTimeline.to({}, 50, {});

  infographicTimeline.set(fbi, {width: '100%'});
  infographicTimeline.add([
    TweenLite.to(blackoutCurtain, 50, {left: '100%'}),
    TweenLite.to(fbiConflict, 25, {opacity: 0, x: '+=25%'}),
  ]);

  animateCallout(fbiMemoCallout, infographicTimeline);

  infographicTimeline.to({}, 25, {});

  infographicTimeline.to(fbiFootnote, 25, {opacity: 1});

  animatePages(pages, infographicTimeline);

  infographicTimeline.to(fbiMemoQuote, 25, {opacity: 1});

  infographicTimeline.to({}, 50, {});

  // now mobile

  infographicTimelinePortrait.to({}, 100, {});

  infographicTimelinePortrait.set(cia, {opacity: 1});
  infographicTimelinePortrait.set(fbi, {opacity: 0});

  infographicTimelinePortrait.to(blackoutCurtain, 50, {right: '100%'});
  infographicTimelinePortrait.add([
    TweenLite.to(ciaConflict, 25, {opacity: 1, x: '0%'}),
    TweenLite.to(ciaFootnote, 25, {opacity: 1}),
  ]);

  infographicTimelinePortrait.to({}, 25, {});

  animateTextHighlights(ciaHighlights, infographicTimelinePortrait);

  infographicTimelinePortrait.to({}, 50, {});

  infographicTimelinePortrait.add([
    TweenLite.to(ciaFootnote, 50, {opacity: 0}),
    TweenLite.to(blackoutCurtain, 50, {right: '0%'}),
  ]);

  infographicTimelinePortrait.set(cia, {opacity: 0});
  infographicTimelinePortrait.set(fbi, {opacity: 1});

  infographicTimelinePortrait.to(blackoutCurtain, 50, {left: '100%'});
  infographicTimelinePortrait.to(fbiConflict, 25, {opacity: 1, x: '0%'});

  infographicTimelinePortrait.to({}, 50, {});

  infographicTimelinePortrait.add([
    TweenLite.to(fbiConflict, 25, {opacity: 0, x: '+=25%'}),
  ]);

  animateCallout(fbiMemoCallout, infographicTimelinePortrait);

  infographicTimelinePortrait.to({}, 25, {});

  infographicTimelinePortrait.to(fbiFootnote, 25, {opacity: 1});

  animatePages(pages, infographicTimelinePortrait);

  infographicTimelinePortrait.to(fbiMemoQuote, 25, {opacity: 1});

  infographicTimelinePortrait.to({}, 50, {});

  infographicSection.addEventListener('scrub', ({detail: {vh}}) => {
    if (portrait.matches) {
      infographicTimelinePortrait.seek(minmax(0, vh, infographicTimelinePortrait.duration()), false);
    } else {
      infographicTimeline.seek(minmax(0, vh, infographicTimeline.duration()), false);
    }
  });
}

